import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { ShareService } from 'src/app/shared/services/share.service';
import { IErrorCode, IFile, IShareData } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-share-options',
  templateUrl: './share-options.component.html',
  styleUrls: ['./share-options.component.scss']
})
export class ShareOptionsComponent implements OnInit, OnDestroy {
  @Input() public shareData: IShareData;
  @Input() public openState: number;
  @Output() openStateChange: EventEmitter<number> = new EventEmitter();

  @Input() showDialog!: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public errors: Array<IErrorCode> = [];

  public isPro = false;
  public spinners = {
    label: false,
  };
  name: string = '';
  public isSmallScreen: boolean = false;
  private breakpointSubscription: Subscription;

  constructor(
    private userService: UserService,
    private loggerService: LoggerService,
    private shareService: ShareService,
    public breakpointObserver: BreakpointObserver,
    private broadcastService: BroadcastService
  ) { }

  ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  

    this.showDialog = true;
    console.log('share-options', this.shareData);

    this.isPro = this.userService.get('is_pro');
    if (!this.shareData) {
      this.loggerService.error(
        'Unable to find shareData for sharemember-option'
      );
      this.loggerService.error(JSON.stringify(this.shareData));
      this.errors.push({
        code: 9000,
        msg: 'No share member information provided',
      });
    }
    this.name = this.shareData['name'];

  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  public async setLabel() {
    try {
      this.spinners.label = true;
      this.errors = [];
      await this.shareService.setLabel(
        this.shareData.shareId,
        this.shareData.label
      );
      this.broadcastService.broadcast('event:file-list.reload');
      this.broadcastService.broadcast('event:share-list.reload');
      this.spinners.label = false;
      this.closeDialog();
    } catch (err) {
      this.spinners.label = false;
      this.errors.push(err);
    }
  }
  private openPopup(state: number) {
    this.openStateChange.next(state);
  }

  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(state>0 ? true : false);
      this.openPopup(state)
    }, 50);
  }
  onBack = () => {
    console.log('onBack options', 5);
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_LIST);
  }
  onUnshare = () => {
    // this.stopShare();
    console.log('onUnshare', 5);

    this.closeDialog(SHARE_DETAILS_OPEN_STATE.REMOVE_SHARING)
  }
}
